const PREFIX = 'MEMBERSHIPS_REIMBURSEMENT';

export const SET_REIMBURSEMENTS_GROUP = `${PREFIX}SET_REIMBURSEMENTS_GROUP`;
export const SET_REIMBURSEMENTS_ITEMS = `${PREFIX}SET_REIMBURSEMENTS_ITEMS`;
export const GET_REIMBURSEMENTS_GROUP = `${PREFIX}GET_REIMBURSEMENTS_GROUP`;
export const GET_REIMBURSEMENTS_GROUP_LIST = `${PREFIX}GET_REIMBURSEMENTS_GROUP_LIST`;
export const SET_REIMBURSEMENTS_GROUP_LIST = `${PREFIX}SET_REIMBURSEMENTS_GROUP_LIST`;